import { createLoadingReducer } from './utils';

export default createLoadingReducer('WEBHOOK_ENDPOINTS');
